<template>
  <div id="app">
    <transition name="route-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}
body {
  margin: 0;
  background: #f5f7fa;
}

* {
  box-sizing: border-box;
}

/* 让 ElementUI 的阴影/圆角更“后台”一些 */
.el-card {
  border-radius: 10px;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:hover,
.el-card.is-hover-shadow:focus {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
}

/* 路由切换动效 */
.route-fade-enter-active,
.route-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.route-fade-enter,
.route-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
</style>

